<template lang="pug">
article-list-page-template.px-lg-15.books-page(
  :title="pageTitle",
  :loading="loading",
  :page="page",
  :pagesLength="pagesLength",
  :pages-total-visible="pagesTotalVisible",
  itemsColWidth="225px"
)
  template(#top)
    v-chip-group.d-flex.align-center.justify-center(
      v-model="categorySelected",
      column
    )
      .d-flex.justify-center.flex-wrap.mx-auto
        v-chip.text-uppercase.font-weight-bold.px-8(
          v-for="({ id, title }, i) in categories",
          :key="id",
          :value="id",
          active-class="secondary black--text",
          color="primary",
          large
        ) {{ title }}
    v-chip-group.d-flex.align-center.justify-center(
      v-model="subcategorySelected",
      column
    )
      .d-flex.justify-center.flex-wrap.mx-auto
        v-chip.text-uppercase.font-weight-bold.px-4(
          v-for="({ id, title }, i) in subcategories",
          :key="id",
          :value="id",
          active-class="secondary black--text",
          color="primary"
        ) {{ title }}
  template(#items)
    ebook-card.mx-auto(
      v-for="({ title, link, img, file }, i) in items",
      :key="i",
      :title="title",
      :link="link",
      :img="img",
      :file="file"
    )
  template(#side)
    communications-widget
</template>

<script>
import ArticleListPageTemplate from "@/components/templates/ArticleListPage.vue";
import EbookCard from "@/components/cards/Ebook";
import CommunicationsWidget from "@/components/widgets/Communications";

const _config = {
  mod: "ebooks",
  categories: "ebooksCategories",
  subcategories: "ebooksSubcategories",
  title: "Biblioteca",
  path: "/biblioteca",
  itemsPerPage: 12,
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
    totalItems: 0,
  }),
  computed: {
    pagesTotalVisible() {
      return this.$vuetify.breakpoint.smAndDown ? 3 : 6;
    },
    page() {
      const p = this.$route.query.p;
      return p ? parseInt(p) : 1;
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
    items() {
      let items = this.$rest(_config.mod).list.map(
        ({ title, link, img, file }) => ({
          title,
          link,
          img: this.files + img,
          file: file && this.files + file,
        })
      );

      return items;
    },
    categories() {
      return this.$rest(_config.categories).list;
    },
    subcategories() {
      if (!this.categorySelected) return [];

      return this.$rest(_config.subcategories).list.filter(
        ({ categories_id }) => categories_id === this.categorySelected
      );
    },
    categorySelected: {
      set(v) {
        const query = { ...this.$route.query };

        if (v) query.c = v;
        else delete query.c;

        this.$router.push({ query });
      },
      get() {
        return this.$route.query.c || null;
      },
    },
    subcategorySelected: {
      set(v) {
        const query = { ...this.$route.query };

        if (v) query.sc = v;
        else delete query.sc;

        this.$router.push({ query });
      },
      get() {
        return this.$route.query.sc || null;
      },
    },
  },
  methods: {
    getItems() {
      this.loading = true;

      const params = {
        returnTotalItems: 1,
        itemsPerPage: _config.itemsPerPage,
      };
      if (this.page) params.page = this.page;
      if (this.categorySelected) params.category = this.categorySelected;
      if (this.subcategorySelected)
        params.subcategory = this.subcategorySelected;

      this.$rest(_config.mod).get({
        params,
        keepCache: true,
        save: (state, { totalItems, list }) => {
          this.totalItems = totalItems;
          state.list = list;
          this.loading = false;
        },
      });
    },
  },
  watch: {
    page() {
      this.getItems();
    },
    categorySelected() {
      this.getItems();
    },
    subcategorySelected() {
      this.getItems();
    },
  },
  created() {
    this.getItems();
    this.$rest(_config.categories).get();
    this.$rest(_config.subcategories).get();
  },
  components: {
    ArticleListPageTemplate,
    EbookCard,
    CommunicationsWidget,
  },
};
</script>

<style>
.books-page .theme--light.v-chip--active::before {
  opacity: 0 !important;
}
</style>
